import React from 'react'
import { Modal, Input } from 'antd'

const AddPropModal = ({
  visible,
  onCancel,
  onOk,
  newPropKey,
  newPropDescription,
  setNewPropDescription
}) => {
  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title="Add New Prop Reference"
      onCancel={onCancel}
      onOk={onOk}
      okText="Generate"
      cancelText="Cancel"
      centered
    >
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>
          Prop Key (Auto-generated):
        </label>
        <Input
          value={newPropKey}
          disabled
          placeholder="__prop1__"
          style={{ background: '#f5f5f5', color: '#555' }}
        />
        <div style={{ marginTop: 4, fontSize: '12px', color: '#888' }}>
          Format:{' '}
          <code
            style={{
              background: '#f5f5f5',
              padding: '2px 6px',
              borderRadius: 3
            }}
          >
            __propX__
          </code>{' '}
          where X is the prop number
        </div>
      </div>
      <div>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>
          Description:
        </label>
        <Input.TextArea
          value={newPropDescription}
          onChange={e => setNewPropDescription(e.target.value)}
          rows={4}
          placeholder="Enter prop description for image generation (e.g., A vintage silver pocket watch with intricate engravings)"
        />
      </div>
    </Modal>
  )
}

export default AddPropModal
